import { IChannelRepository } from '../../core/repositories/interfaces/iChannelRepository';
import {
    IChannelsResponse,
    IGetChannelsMiniEPGParams,
    IGetChannelsParams,
    IMiniEPGResponse,
    IGetChannelScheduleResponse,
    IGetChannelScheduleParams,
    IGetChannelInfoParams,
    IChannelInfoResponse,
} from '../../entity';

import { IHttpAdapter } from '../../core/entities/iHttpAdapter';
import { API_IDS } from '@intigral/constant/endpoint/ApiIdMapper';

import { container } from '../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { IApiPathManager } from '../config/ApiPathManager';

class ChannelRepository implements IChannelRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get appKey(): string {
        return process.env['NX_PUBLIC_WCP_STATIC_API_KEY'] || 'NX_PUBLIC_WCP_STATIC_API_KEY';
    }

    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async getChannelsArrisSTB(params: IGetChannelsParams): Promise<IChannelsResponse> {
        const path = this.apiPathManager.getPath(API_IDS.CONTENT_CHANNELS_ARRIS_STB);
        const response = await this.http.get<IChannelsResponse>(path, {
            params: { ...params, appKey: this.appKey },
        });
        return response.data;
    }
    async getChannels(params: IGetChannelsParams): Promise<IChannelsResponse> {
        const path = this.apiPathManager.getPath(API_IDS.CHANNELS);
        const response = await this.http.get<IChannelsResponse>(path, {
            params: { ...params, appKey: this.appKey },
        });
        return response.data;
    }

    async getChannelInfo(params: IGetChannelInfoParams): Promise<IChannelInfoResponse> {
        const path = this.apiPathManager.getPath(API_IDS.CONTENT_CHANNELS);
        const response = await this.http.get<IChannelInfoResponse>(path, {
            params: { ...params, appKey: this.appKey, byCustomValue: '{device}{country}' },
        });
        return response.data;
    }

    async getChannelsMiniEPG(params: IGetChannelsMiniEPGParams): Promise<IMiniEPGResponse> {
        const path = this.apiPathManager.getPath(API_IDS.CONTENT_CHANNELS_MINI_EPG);
        const response = await this.http.get<IMiniEPGResponse>(path, {
            params: { ...params, appKey: this.appKey },
        });
        return response.data;
    }

    async getChannelSchedule(params: IGetChannelScheduleParams): Promise<IGetChannelScheduleResponse> {
        const path = this.apiPathManager.getPath(API_IDS.CONTENT_CHANNELS_CDN_SCHEDULE);
        const response = await this.http.get<IGetChannelScheduleResponse>(path, {
            params: { ...params },
        });
        return response.data;
    }

    async getChannelScheduleByDataSource(
        datasource: string,
        params: IGetChannelScheduleParams
    ): Promise<IGetChannelScheduleResponse> {
        const url = this.apiPathManager.replacePlaceholders(datasource);
        const response = await this.http.get<IGetChannelScheduleResponse>(url, {
            params: { ...params },
        });
        return response.data;
    }
}

export default ChannelRepository;
